export { productFormSchema } from './productValidation';
export { generateKeywords } from './keywordsGenerator';
import { productFormSchema } from './productValidation';

// Валидация продукта (можно использовать для дополнительной проверки)
export const validateProduct = (data: unknown) => {
    return productFormSchema.validateSync(data);
};

/** Миниатюра товара: уменьшенная копия, если она есть. */
export function productThumbSrc(
    image: { url?: string | null; cardUrl?: string | null } | null | undefined,
): string | null {
    const src = image?.cardUrl || image?.url;
    return src || null;
}

// Форматирование цены
export const formatPrice = (price: number): string => {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
    }).format(price);
};

